// extracted by mini-css-extract-plugin
module.exports = {"footer-copyright":"FooterCopyright_footer-copyright__tYhFC"};